import { UpstreamEvent } from 'client';
import React from 'react';
import { useSearchParams } from 'react-router';
import { useFilterFormListener } from 'routes/components/filter-form-context';
import { PillButtonToggle } from 'routes/components/pill-button';

import { getFilterParamKey } from 'DesignSystem/features/table-context/filter-param';
import { Switch } from 'DesignSystem/ui/switch';
import { FilterComponentProps } from 'types/react-table';

export function HasImpactedLocationsToggle(props: FilterComponentProps<UpstreamEvent>) {
  const [searchParams, _setSearchParams] = useSearchParams();
  const paramKey = getFilterParamKey(props.meta.filter?.param) ?? '';
  const [checked, setChecked] = React.useState(searchParams.get(paramKey) === 'true');

  useFilterFormListener(
    React.useCallback((event) => {
      if (event.type === 'CLEAR') {
        setChecked(false);
      }
    }, [])
  );

  return (
    <label className="flex items-center justify-start gap-2">
      {checked ? <input type="hidden" name={paramKey} value="true" /> : null}
      <Switch variant="purple" checked={checked} onCheckedChange={setChecked} />
      <span>{props.meta.label}</span>
    </label>
  );
}

export function HasImpactedLocationsTogglePill(props: FilterComponentProps<UpstreamEvent>) {
  return <PillButtonToggle label={props.meta.label ?? ''} param={getFilterParamKey(props.meta.filter?.param)} />;
}
